import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import styles from './Pill.module.scss'

const Pill = ({ className, children, onClick, ...restProps }) => {
  return (
    <button
      className={classnames(styles.pill, className)}
      onClick={onClick}
      {...restProps}
    >
      {children}
    </button>
  )
}

Pill.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
    PropTypes.node,
  ]),
  onClick: PropTypes.func,
}

export default Pill
